"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var box_1 = require("./box");
var styled_system_1 = require("styled-system");
var texts = styled_system_1.variant({ key: "textStyles" });
exports.Text = styled_1.default(box_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"])), styled_system_1.fontFamily, styled_system_1.fontWeight, styled_system_1.textAlign, styled_system_1.lineHeight, styled_system_1.letterSpacing, texts, function (p) { return p.theme["Text"]; }, styled_system_1.color);
exports.Text.defaultProps = {
    as: "p",
    m: 0,
    p: 0,
    fontSize: 2
};
var templateObject_1;
